import Controller from '@ember/controller';

export default class HotelParityController extends Controller {}
